import { CustomRequestInit } from "@/typings";
import {
  CLIENT_TYPE_WEB_H5,
  TRACK_DOMAIN_API,
  YOO_FINDS_DOMAIN_API,
} from "../common";
import omit from "./omit";
import { buildClientInfo, getTimeZone } from "./deviceInfo";
import { getToken } from "./get-app-info";

export async function fetchData<T>(
  url: string,
  params?: CustomRequestInit
): Promise<T> {
  try {
    const deviceHeaders = await buildClientInfo(params);

    const token = await getToken();

    const newParams: RequestInit = {
      method: "GET",
      credentials: "include",
      ...params,
      headers: {
        "Content-Type": "application/json",
        Authorization: token || "",
        "Client-Info": JSON.stringify({
          client: CLIENT_TYPE_WEB_H5,
          time: Date.now(),
          ...omit(deviceHeaders, ["userAgent"]),
          timezone: getTimeZone(),
        }),
        ...params?.headers,
      },
    };
    const res = await fetch(url, newParams);

    if (!res.ok) {
      const response = await res.json();
      throw new Error(JSON.stringify(response));
    }
    const response = await res.json();

    return response as T;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }

    if (typeof error === "object" && error && "message" in error) {
      throw new Error((error as any).message);
    }

    throw new Error(JSON.stringify(error));
  }
}

export async function fetchYooFindsApi<T>(
  url: string,
  params?: CustomRequestInit
): Promise<T> {
  return await fetchData<T>(`${YOO_FINDS_DOMAIN_API}${url}`, params);
}

export async function fetchTrackApi<T>(
  url: string,
  params?: CustomRequestInit
): Promise<T> {
  return await fetchData<T>(`${TRACK_DOMAIN_API}${url}`, params);
}
